import { render, staticRenderFns } from "./ModalRegraDeCalculoIncluirSetorAtendimento.vue?vue&type=template&id=32c6f819&scoped=true"
import script from "./ModalRegraDeCalculoIncluirSetorAtendimento.vue?vue&type=script&lang=ts"
export * from "./ModalRegraDeCalculoIncluirSetorAtendimento.vue?vue&type=script&lang=ts"
import style0 from "./ModalRegraDeCalculoIncluirSetorAtendimento.vue?vue&type=style&index=0&id=32c6f819&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c6f819",
  null
  
)

export default component.exports